// Optional filter-as-you-type behaviour for ComboBox. Lives in its own module
// so the core ComboBox stays focused on listbox/keyboard interactions and
// callers opt in via `enableFiltering`.

export const filterComboBoxData = (
  data: string[],
  inputValue: string,
  value: string
): string[] => {
  const search = inputValue.trim().toLowerCase();
  // While the input still matches the externally-tracked `value` (e.g. just
  // after focus on an existing selection), keep the full list visible so the
  // user can browse without first clearing the field.
  if (!search || search === value.trim().toLowerCase()) return data;
  return data.filter((item) => item.toLowerCase().includes(search));
};
